module.exports = __webpack_public_path__ + "img/avatar5.4cbe5495.png";